import Breadcrumbs from "@components/ui-components/breadcrumbs";
import Card from "@components/ui-components/card";
import Charts from "@components/charts";
import DateRangePicker from "@src/@core/components/fields/date-picker/range-picker";
import Flex from "@components/ui-components/flex";
import { Fragment } from "react";
import { LAST_30_DAYS_DATE } from "@src/utility/constants";
import { LoaderOverlay } from "@src/@core/components/spinner";
import StatsFormatter from "@components/formatters/stats-formatter";
import useDateHandler from "@src/utility/hooks/use-date-handler";
import useRevenueReport from "./use-revenue-report";
import { useTranslation } from "react-i18next";
import { yAxisConfig } from "./misc/constants";
const RevenueReport = () => {
    const {
        data: { chart, widgets },
        getRevenueReport,
        loading
    } = useRevenueReport();
    const { control, handleDateChange } = useDateHandler({
        onSubmit       : getRevenueReport,
        defaultValues  : LAST_30_DAYS_DATE,
        defaultHandling: true
    });
    const { t } = useTranslation();
    const widgetSections = [
        { id: "total", label: "Total", nextOperator: "=", value: widgets.total },
        { id: "new", label: "New", nextOperator: "+", value: widgets.new },
        { id: "expansion", label: "Expansion", nextOperator: "+", value: widgets.expansion },
        { id: "existing", label: "Existing", nextOperator: "-", value: widgets.existing },
        { id: "contractions", label: "Contractions",  value: widgets.contractions }
    ];

    return (
        <>
            <Breadcrumbs
                items={[
                    {
                        title : "Revenue",
                        active: true
                    }
                ]}
                rightChildren={
                    <Flex align="center">
                        <DateRangePicker
                            control={control}
                            customOnChange={handleDateChange}
                            maxDate={new Date()}
                            id="date"
                            name="date"/>
                    </Flex>
                }/>
            <LoaderOverlay
                active={loading}
                children={
                    <Card>
                        <p className="fw-bolder font-medium-3">
                            {t("MRR Overview")}
                        </p>

                        <Flex className="w-100 px-3 mt-1" justify="between" align="center">
                            {widgetSections.map(({ id, label, nextOperator, value }) => (
                                <Fragment key={id}>
                                    <Flex className="mt-1" column align="center">
                                        <StatsFormatter
                                            className="font-large-1 fw-bolder"
                                            id={id}
                                            prefix="$"
                                            num={value}/>
                                        <p>{t(label)}</p>
                                    </Flex>
                                    { nextOperator ? <h1>{nextOperator}</h1> : null}
                                </Fragment>
                            ))}
                        </Flex>

                        <Charts
                            categories={chart.categories}
                            series={chart.series}
                            yAxis={yAxisConfig}/>
                    </Card>
                }/>
        </>
    );
};

export default RevenueReport;
